export const mapToPrediccionPartido = (data) => {
    if (!data) return null;

    return {
        predictions: {
            winner: {
                id: data?.p?.w?.i,
                name: data?.p?.w?.n,
                comment: data?.p?.w?.c,
            },
            win_or_draw: data?.p?.wd,
            under_over: data?.p?.u,
            goals: {
                home: data?.p?.g?.h,
                away: data?.p?.g?.a,
            },
            advice: data?.p?.a,
            percent: {
                home: data?.p?.p?.h,
                draw: data?.p?.p?.d,
                away: data?.p?.p?.a,
            },
        },
        comparison: {
            form: {
                home: data?.c?.f?.h,
                away: data?.c?.f?.a,
            },
            att: {
                home: data?.c?.a?.h,
                away: data?.c?.a?.a,
            },
            def: {
                home: data?.c?.d?.h,
                away: data?.c?.d?.a,
            },
            poisson_distribution: {
                home: data?.c?.p?.h,
                away: data?.c?.p?.a,
            },
            h2h: {
                home: data?.c?.h?.h,
                away: data?.c?.h?.a,
            },
            goals: {
                home: data?.c?.g?.h,
                away: data?.c?.g?.a,
            },
            total: {
                home: data?.c?.t?.h,
                away: data?.c?.t?.a,
            },
        },
        teams: data.t,
        ai: data.ai,
        fixture: {
            home: {
                id: data?.f?.h?.i,
                name: data?.f?.h?.n,
                goals: data?.f?.h?.g,
            },
            away: {
                id: data?.f?.a?.i,
                name: data?.f?.a?.n,
                goals: data?.f?.a?.g,
            },
            date: data?.f?.d,
            league: data?.f?.l,
            stadium: data?.f?.s,
            round: data?.f?.r,
            id: data?.f?.i,
        },
    };
};
